export default __webpack_public_path__ + "static/O0089-0e0083d4a712eecdbfe14718ae3b9eb1.png";